import { defineComponent as _, ref as $, toRefs as E, watch as M, onUpdated as T, computed as g, resolveComponent as k, openBlock as a, createBlock as d, Teleport as K, createElementVNode as b, withKeys as h, createVNode as C, Transition as y, withCtx as v, createElementBlock as B, createCommentVNode as i, normalizeClass as H, renderSlot as N } from "vue";
import { _ as O } from "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import R from "../VIconButton/VIconButton.js";
import { useRDialogFocus as z } from "../../../composables/useRDialogFocus.js";
import { S as q } from "../../../Spacing-695d3b19.js";
import { _ as j } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../composables/useSpacingClass.js";
import "../VIcon/VIcon.js";
const F = _({
  name: "VModalDialog",
  components: {
    VIconButton: R,
    VHeadline: O
  },
  emits: ["modal-dialog:close-clicked", "modal-dialog:back-arrow-clicked"],
  props: {
    /**
     * Use by the openCTA element, to link it with aria-controls
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * Used to label the modal for screen readers.
     */
    modalDialogTitleId: {
      type: String,
      required: !0
    },
    /**
     * Flag telling if the modal is visible
     */
    isVisible: {
      type: Boolean,
      default: !1
    },
    /**
     * If set to true, you will
     * have a close button somewhere else
     * and fire the close event there.
     * It is good to focus the first interactive element in a modal.
     * If your modal has only text, focus the close button by sending the ref to it
     * in the prop: focusElement
     */
    delegateHandleClose: {
      type: Boolean,
      default: !1
    },
    /**
     * Ref to the CTA that opens the modal
     */
    openCtaRef: {
      type: Object,
      default: null
    },
    /**
     * Ref to the first element to focus inside the modal.
     * If not provided will focus the modal itself.
     * If not set, the focus will be set to the modal itself.
     */
    focusElement: {
      type: Object,
      default: null
    },
    /**
     * Values: fullScreen, drawer, empty for max-content and centered
     */
    showAs: {
      type: String,
      default: "fullScreenModal"
    },
    showBackArrow: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      default: ""
    },
    isScrolling: {
      type: Boolean,
      default: !1
    },
    handlesColor: {
      type: String,
      default: "#222222"
    }
  },
  setup(e, { emit: t }) {
    const c = $(null), { focusElement: u, openCtaRef: m, isVisible: s, showAs: l } = E(e), { focusOpenCTAComponentInstance: f, focusElementInModal: n, focusModal: w } = z();
    function p({
      lockKeyboardEvents: r = !1,
      lockScroll: I = !1
    }) {
      const o = document.querySelector("body");
      r ? o == null || o.setAttribute("disabled", "true") : o == null || o.removeAttribute("disabled"), I ? o == null || o.setAttribute("style", "overflow: hidden") : o == null || o.removeAttribute("style");
    }
    M(s, (r) => {
      r && l.value !== "drawer" && p({ lockKeyboardEvents: !0, lockScroll: !0 });
    }), T(() => {
      s.value && (u.value ? n(u.value) : w(c));
    });
    const S = () => {
      m.value && f(m.value), l.value !== "drawer" && p({ lockKeyboardEvents: !1, lockScroll: !1 }), t("modal-dialog:close-clicked");
    }, V = () => {
      t("modal-dialog:back-arrow-clicked");
    }, A = g(() => `anim-hobi-modal-dialog-content--${["modalDrawer", "drawer"].includes(l.value) ? "slideRight" : l.value}`), D = g(() => s.value && !["fullScreenModal", "drawer"].includes(l.value));
    return {
      onCloseClick: S,
      onBackArrowClick: V,
      modalDialog: c,
      focusModal: w,
      dialogTransitionName: A,
      showBackgroundOverlay: D,
      Spacing: q
    };
  }
});
const U = ["id", "aria-labelledby"], G = { class: "hobi-modal-dialog-content__header" };
function J(e, t, c, u, m, s) {
  const l = k("VIconButton"), f = k("VHeadline");
  return a(), d(K, { to: "body" }, [
    b("div", {
      class: "hobi-modal-dialog",
      ref: "modalDialog",
      "aria-modal": "true",
      role: "dialog",
      id: e.id,
      "aria-labelledby": e.modalDialogTitleId,
      tabindex: "-1",
      onKeydown: t[1] || (t[1] = h((...n) => e.onCloseClick && e.onCloseClick(...n), ["esc"]))
    }, [
      C(y, { name: "anim-hobi-fade-modal-dialog-background" }, {
        default: v(() => [
          e.showBackgroundOverlay ? (a(), B("div", {
            key: 0,
            onClick: t[0] || (t[0] = (...n) => e.onCloseClick && e.onCloseClick(...n)),
            class: "hobi-modal-dialog-background sm:tw-fixed sm:tw-top-0 sm:tw-bottom-0 sm:tw-left-0 sm:tw-right-0"
          })) : i("", !0)
        ]),
        _: 1
      }),
      C(y, { name: e.dialogTransitionName }, {
        default: v(() => [
          e.isVisible ? (a(), B("div", {
            key: 0,
            class: H(["hobi-modal-dialog-content tw-fixed tw-h-full tw-w-full tw-bg-white tw-top-0 tw-left-0 sm:tw-w-max sm:tw-h-max sm:tw-top-2/4 sm:tw-left-2/4 sm:tw--translate-x-1/2 sm:tw--translate-y-1/2", `hobi-modal-dialog-content--${e.showAs}`]),
            role: "document"
          }, [
            b("div", G, [
              e.showBackArrow ? (a(), d(l, {
                key: 0,
                symbol: "chevron-left",
                color: e.handlesColor,
                size: "24",
                class: "hobi-modal-dialog-back-arrow tw-absolute tw-h-10 tw-w-10 tw-top-4 tw-left-4",
                onClick: e.onBackArrowClick
              }, null, 8, ["color", "onClick"])) : i("", !0),
              e.title && e.isScrolling ? (a(), d(f, {
                key: 1,
                size: "xs",
                center: !0,
                title: e.title,
                "top-spacing": e.Spacing.l,
                "bottom-spacing": e.Spacing.l,
                class: "hobi-modal-dialog-headline tw-absolute tw-left-0 tw-right-0 tw-text-center"
              }, null, 8, ["title", "top-spacing", "bottom-spacing"])) : i("", !0),
              e.delegateHandleClose ? i("", !0) : (a(), d(l, {
                key: 2,
                symbol: "close",
                color: e.handlesColor,
                size: "24",
                class: "hobi-modal-dialog-close tw-absolute tw-h-10 tw-w-10 tw-top-4 tw-right-4",
                onClick: e.onCloseClick,
                onKeydown: h(e.onCloseClick, ["enter"]),
                ref: "closeButton"
              }, null, 8, ["color", "onClick", "onKeydown"]))
            ]),
            N(e.$slots, "content", {}, void 0, !0)
          ], 2)) : i("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 40, U)
  ]);
}
const oe = /* @__PURE__ */ j(F, [["render", J], ["__scopeId", "data-v-9f730289"]]);
export {
  oe as default
};
